import React from 'react';
import classNames from 'classnames';
import './SimpleSwitch.less';

export interface ISimpleSwitchProps {
  /** true for "on", otherwise "off" */
  on: boolean;
  onToggle: (id?: string) => void;
  className?: string;
  id?: string;
}

const getClassName = (on: boolean, className?: string) =>
  classNames('dpc-simple-switch', className, {
    'dpc-simple-switch--on': on,
  });

/**
 * A basic checkbox style/sized toggle (with no inner text)
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function SimpleSwitch({ className, id, on, onToggle }: ISimpleSwitchProps) {
  return (
    <label className={getClassName(on, className)}>
      <input
        type="checkbox"
        checked={on}
        onChange={e => {
          e.stopPropagation();
          onToggle(id);
        }}
        className="dpc-simple-switch__input"
      />
      <i className="dpc-simple-switch__toggle" />
    </label>
  );
}
